const production = true;

const APP_CONFIG = {
	allowedFileTypes: ['mp4', 'y4m', 'mov', 'mkv', 'avi', 'ts', 'webm', 'jpg', 'jpeg', 'png', 'gif', 'bmp'],
	maxFileSizeInGB: 0.4,
	apiUrl: production ? '/api/' : 'http://localhost:3000/api/'
};

export default APP_CONFIG;
